
<template>
    <div>
        <md-card class="card_full_screen">
            <md-card-content>
                <ValidationObserver ref="valObserver">
                    <form>
                        <FadeTransition :duration="400" mode="out-in" v-if="!loading">
                            <div class="md-layout md-alignment-top-left">

                                <div class="md-layout-item md-size-100 md-small-size-100 md-medium-size-100 md-xlarge-size-100">
                                    <div class="title_with_btns">
                                        <div class="titles">
                                            <h3 class="zero_b_margin">{{website.name}}</h3>
                                            <p class="vertically_tight">{{website.address}}</p>
                                        </div>
                                        <website-menu></website-menu>
                                        <div class="btns">
                                            <div class="btns_sxs">
                                                <md-button @click="addTenant" title="Add Tenant" class="md-info">Add</md-button>
                                                <md-button class="md-primary" @click="save" title="Attempt to save all changes">Save All</md-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="md-layout-item md-size-100">

                                    <div class="md-layout md-gutter">

                                        <div class="md-layout-item md-size-15 md-medium-size-50 md-small-size-50">
                                            <div class="md-layout">
                                                <tenants-logos class="md-layout-item md-size-100" :files="website.files"></tenants-logos>
                                            </div>

                                            <div class="md-layout">
                                                <div class="md-layout-item md-size-100">
                                                    <p>
                                                        Unassigned
                                                    </p>
                                                    <draggable :list="website.files.unassigned" class="list-group source-list logos_list"
                                                               :sort="false" drag-class="being-dragged" ghost-class="ghost" force-fallback="true" fallback-class="being-dragged" group="files">
                                                        <file-item v-for="file in website.files.unassigned"
                                                                   :key="file.id" :file="file"
                                                                   class="list-group-item md-elevation-5"></file-item>
                                                    </draggable>
                                                </div>
                                            </div>

                                            
                                            <div class="md-layout">
                                                <div class="md-layout-item md-size-100">
                                                    <p>
                                                        To Delete
                                                    </p>
                                                    <draggable :list="filesToDelete" class="list-group source-list logos_list"
                                                               :sort="false" drag-class="being-dragged" ghost-class="ghost" force-fallback="true" fallback-class="being-dragged" group="files">
                                                        <file-item v-for="file in filesToDelete"
                                                                   :key="file.id" :file="file"
                                                                   class="list-group-item md-elevation-5"></file-item>
                                                    </draggable>
                                                </div>
                                            </div>
                                        </div>




                                        <tenants-table :files="website.files" :showChosenSwitch="true" ref="tenantsTable" :tenantsDetails="website.tenants.tenantsDetails" class="md-layout-item md-size-85"></tenants-table>

                                    </div>


                                </div>




                            </div>
                        </FadeTransition>
                        <div class="loader_wrap" v-if="loading">
                            <loader></loader>
                        </div>
                    </form>
                </ValidationObserver>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
    import { FadeTransition, ZoomCenterTransition } from "vue2-transitions";
    import Loader from "@/components/Loader.vue";

    import Help from "@/ts/Help";
    import NotyTypes from "@/ts/NotyTypes";
    import Api from '@/ts/UvApiService';

    import WebsiteMenu from "./WebsiteMenu.vue";

    import TenantsLogos from "@/pages/Dashboard/Buildings/TenantsLogos.vue";
    import TenantsTable from "@/pages/Dashboard/Buildings/TenantsTable.vue";

    import draggable from 'vuedraggable';
    import FileItem from "@/pages/Dashboard/Buildings/FileItem.vue";

    export default {
        components: {
            Loader
            , FadeTransition
            , WebsiteMenu
            , TenantsLogos
            , TenantsTable
            , draggable
            , FileItem
        },
        data() {
            return {
                loading: true,
                website: null,
                filesToDelete: []
            }
        },
        computed: {

        },
        methods: {
            addTenant() {
                this.$refs.tenantsTable.addTenant();
            },
            async runCustomValidation() {
                var result = await this.$refs.tenantsTable.validateTable();
                return result;
            },
            async fetchData() {
                if (!Help.isNullOrUndef(this.$route.params.buildingId)) {
                    if (Help.isNullOrUndef(this.website)) {
                        var res = await Api.websites.getWebsiteTenants(this.$route.params.buildingId);
                        this.website = res;
                    }
                    this.loading = false;
                }
            },
            async save() {
                var result = await this.runCustomValidation();
                if (result.valid) {
                    await this.validatePageSaveOrAlert();
                }
                else {
                    this.notifyErrors(result.errors);
                }
            },
            async validatePageSaveOrAlert() {
                this.$refs.valObserver.validate().then(async success => {
                    if (!success) {
                        setTimeout(() => {
                            this.notifyErrors(Object.values(this.$refs.valObserver.errors));
                        }, 100);
                        return;
                    }
                    else {
                        await this.saveRaw();
                        //this.$router.push(this.nextUrl);
                    }
                });
            },
            async saveRaw() {
                var res = await Api.websites.upsertTenants(this.website);
                if (res.success === true) {
                    alert("that worked");
                }
                else {
                    this.showServerFailMessage(res, "saving all");
                }
            },
            notifyErrors(errorsArray) {
                var errorsLis = "";
                errorsArray.forEach((e) => {
                    if (e.length > 0) {
                        e.flat().forEach((ei) => {
                            errorsLis += `<li>${Help.removeFullStop(ei)}</li>`;
                        });
                    }
                });
                this.$notify({
                    timeout: 10000,
                    message: `Please <b>fix all errors</b> on the current page <b>to proceed</b><ul>${errorsLis}</ul>`,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            showServerFailMessage(res, action) {
                var msg = res.message ?? `Unknown problem on the server ${action} this building`;
                this.$notify({
                    timeout: 10000,
                    message: msg,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            }
        },
        async mounted() {
            await this.fetchData();
        },

    }
</script>
<style lang="scss">
    .md-switch.md-disabled .md-switch-container {
        background-color: rgba(80, 80, 80, 0.1) !important;
    }

    .icon_cell {
        padding-top: 16px;
    }

        .icon_cell .disabled {
            background-color: rgba(80, 80, 80, 0.1) !important;
            pointer-events: none;
            opacity: 0.6;
        }

    .fixed_preview {
        max-width: 25%;
        max-width: 255px;
        position: fixed;
        right: 40px;
        top: 200px;
    }

    .amenity_group {
        border-bottom: solid 1px rgba(0,0,0,0.2);
        margin-bottom: 10rem;
    }

    .amenity_row {
        border-bottom: solid 1px rgba(208, 186, 186, 0.10);
        padding-top: 2rem;
        padding-bottom: 4rem;
    }
</style>